import { saveAs } from 'file-saver';

/* Izvoz u .xlsx (ExcelJS, učitava se tek kad zatreba — ne ulazi u glavni bundle).
   Stil: naslov, podnaslov, zaglavlje podebljano sa sivom pozadinom, tanke ivice, auto širina (max 60).
   Jedan list: exportXlsx({ fileName, sheetName, title, subtitle, columns, rows, rowStyle })
   Više listova: exportXlsx({ fileName, sheets: [{ sheetName, title, subtitle, columns, rows, rowStyle }, ...] }) */

const BORDER = { style: 'thin', color: { argb: 'FFCBD3CF' } };

function fillSheet(wb, { sheetName = 'Izveštaj', title, subtitle, columns, rows, rowStyle }) {
    const ws = wb.addWorksheet(String(sheetName).replace(/[\\/?*[\]:]/g, ' ').slice(0, 31));
    let r = 1;
    if (title) {
        ws.getCell(r, 1).value = title;
        ws.getCell(r, 1).font = { bold: true, size: 14 };
        r += 1;
    }
    if (subtitle) {
        ws.getCell(r, 1).value = subtitle;
        ws.getCell(r, 1).font = { italic: true, color: { argb: 'FF5F6F69' } };
        r += 1;
    }
    if (title || subtitle) r += 1;
    const header = ws.getRow(r);
    columns.forEach((c, i) => {
        const cell = header.getCell(i + 1);
        cell.value = c.header;
        cell.font = { bold: true };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEFF3F1' } };
        cell.border = { top: BORDER, bottom: { style: 'medium' }, left: BORDER, right: BORDER };
        cell.alignment = { vertical: 'middle', wrapText: true };
    });
    ws.views = [{ state: 'frozen', ySplit: r }];
    rows.forEach((row) => {
        r += 1;
        const xr = ws.getRow(r);
        columns.forEach((c, i) => {
            const cell = xr.getCell(i + 1);
            const v = typeof c.value === 'function' ? c.value(row) : row[c.key];
            cell.value = v == null ? '' : v;
            if (v instanceof Date) cell.numFmt = c.numFmt || 'dd.mm.yyyy hh:mm';
            else if (c.numFmt) cell.numFmt = c.numFmt;
            cell.border = { top: BORDER, bottom: BORDER, left: BORDER, right: BORDER };
            cell.alignment = { vertical: 'top', wrapText: !!c.wrap };
        });
        if (rowStyle) rowStyle(xr, row);
    });
    columns.forEach((c, i) => {
        const col = ws.getColumn(i + 1);
        if (c.width) { col.width = c.width; return; }
        let max = String(c.header).length;
        col.eachCell({ includeEmpty: false }, (cell) => {
            const v = cell.value instanceof Date ? 'dd.mm.yyyy hh:mm' : String(cell.value ?? '');
            if (cell.row > (title || subtitle ? 2 : 0)) max = Math.max(max, v.length);
        });
        col.width = Math.min(60, max + 2);
    });
}

export async function exportXlsx(opts) {
    const { default: ExcelJS } = await import('exceljs');
    const wb = new ExcelJS.Workbook();
    wb.creator = 'Tacho Royal Team';
    (opts.sheets || [opts]).forEach((s) => fillSheet(wb, s));
    const buf = await wb.xlsx.writeBuffer();
    saveAs(new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), opts.fileName);
}

/** Popuna reda bojom (ARGB) — npr. istekao rok. */
export const obojiRed = (row, argb) => row.eachCell((cell) => { cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb } }; });

/** dd.MM.yyyy HH.mm za imena fajlova (bez dvotačke, Windows je ne dozvoljava). */
export const stampaVremena = (d = new Date()) => {
    const p = (n) => String(n).padStart(2, '0');
    return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} ${p(d.getHours())}.${p(d.getMinutes())}`;
};
